import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { borrowingQuotaShape } from '@bibliocommons/bc-prop-types';

import BorrowingUtilityBarTitle from '../../shared/BorrowingUtilityBarTitle';
import MaterialTypeFilterLinks from '../../shared/MaterialTypeFilterLinks';
import HoldsQuotasPopOver from '../HoldsQuotasPopOver';
import HoldStatusIcon from '../HoldStatusIcon';
import BorrowingUtilityBar from '../../shared/BorrowingUtilityBar';

import './HoldsUtilityBar.scss';

export default class HoldsUtilityBar extends BcReactComponent {
  showFilterLinks() {
    const { materialTypeCounts } = this.props;

    return materialTypeCounts &&
      materialTypeCounts.get('DIGITAL', 0) > 0 &&
      materialTypeCounts.get('PHYSICAL', 0) > 0;
  }

  renderStatusIcon() {
    if (this.props.status) {
      return <HoldStatusIcon status={this.props.status} withBackground />;
    }

    return null;
  }

  renderTitle() {
    return (
      <div>
        <BorrowingUtilityBarTitle
          status={this.props.status}
          statusIcon={this.renderStatusIcon()}
          count={this.props.totalCount} />
        {this.showFilterLinks() && <MaterialTypeFilterLinks
          totalCount={this.props.totalCount}
          materialTypeCounts={this.props.materialTypeCounts} />}
        {this.props.allItemsDigital && <HoldsQuotasPopOver quotas={this.props.quotas} />}
      </div>
    );
  }

  render() {
    return (
      <BorrowingUtilityBar
        className="cp-holds-utility-bar"
        title={this.renderTitle()}
        printURL={this.props.printURL}
        pagination={this.props.pagination}
        sortOptions={this.props.sortOptions} />
    );
  }
}

HoldsUtilityBar.propTypes = {
  allItemsDigital: PropTypes.bool,
  status: PropTypes.string,
  totalCount: PropTypes.number,
  materialTypeCounts: ImmutablePropTypes.mapContains({
    PHYSICAL: PropTypes.number,
    DIGITAL: PropTypes.number
  }),
  pagination: ImmutablePropTypes.map,
  sortOptions: ImmutablePropTypes.list,
  handleSort: PropTypes.func,
  printURL: PropTypes.string,
  quotas: ImmutablePropTypes.listOf(borrowingQuotaShape)
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsUtilityBar/HoldsUtilityBar.jsx